module.exports = __webpack_public_path__ + "assets/66ba9b99b835f21df4a2daa0e5c28b98.mp3";